import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AuthProvider from "./hooks/AuthProvider";

import Home from './pages/Home/index';
import About from './pages/About/index';
import Contact from './pages/Contact/index';
import Listings from './pages/Listings/index';
import Login from './pages/Login/index';
import Pricing from './pages/Pricing/index';
import SignUp from './pages/SignUp/index';
import Navigation from './components/navigation/Navigation';
import SiteFooter from './components/site-footer/SiteFooter';
import PrivateRoute from './auth/PrivateRoute';

import './assets/css/base/App.css';
import './assets/css/animations/Entrances.css';
import { DirectoryProvider } from './contexts/DirectoryContext';
import EmployeeDirectoryUpdates from './pages/EmployeeDirectoryUpdates';

function App() {
  return (
    <Router>
      <AuthProvider>
        <DirectoryProvider>
          <Navigation />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<PrivateRoute />}>
              <Route path="/employeedirectoryupdates" element={<EmployeeDirectoryUpdates />} />
            </Route>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/signup/:id" element={<SignUp />} />
          </Routes>
          <SiteFooter />
        </DirectoryProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;